"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var t=String,e=function(r){try{return t(r)}catch{return"Object"}};exports.tryToString=e;
